import { render } from "./CampaignGoal.vue?vue&type=template&id=3ea3d3b7"
import script from "./CampaignGoal.vue?vue&type=script&lang=js"
export * from "./CampaignGoal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__